import React, { memo } from 'react'
import SVG from 'react-inlinesvg'

import { Box, BoxProps } from '@mui/material'

export interface Props extends BoxProps {
  data: Queries.accreditationFragment
}

const AccreditationCard = ({ data, ...props }: Props) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" {...props}>
      <SVG src={data.logo.url} width="auto" height="100%" />
    </Box>
  )
}

export default memo(AccreditationCard)
